import Vue from 'vue'
import '../components/PayQrcode.js'
import $payApi from '@/utils/http/modules/pay.request.js'

const PAYRESULTMSG = {
  success: '支付成功', // { message: 'success', orderId: result.code }
  fail: '支付失败', // 微信jsapi报错 { message: 'fail', orderId: result.code }
  cancel: '支付取消', // { message: 'cancel', orderId: result.code }
  error: '支付异常' // 自己代码问题 { message: 'error' }
}
const { $toast } = Vue.prototype
Vue.prototype.$payment = payment
// 0元支付  不唤起微信支付
const noWxPayCode = ['001600', '001801']
async function payment(params, config = {}) {
  try {
    var result = await $payApi.payment(
      Object.assign({ t: isTest() ? 2 : 1, zbId: window.zbvd.zbid }, params)
    )
    console.log('payment result =>', result)
    if (result.isok) {
      // 0元支付
      if (noWxPayCode.includes(result.code)) {
        return { message: 'success', orderId: result.code }
      } else if (result.Msg && (isTest() || !isPhoneWeChat())) {
        // 测试环境唤起支付
        window.payQrcode.show({ msg: result.Msg })
        await getState(result.code)
        window.payQrcode.close()
        !config.hideMsg && $toast(PAYRESULTMSG['success'])
        return { message: 'success', orderId: result.code }
      } else if (result.Msg) {
        return await new Promise(function (resolve, reject) {
          wxCallPay(result.Msg, payres => {
            console.log('wxCallPay res =>', payres)
            if (payres.err_msg === 'get_brand_wcpay_request:ok') {
              !config.hideMsg && $toast(PAYRESULTMSG['success'])
              resolve({ message: 'success', orderId: result.code })
            } else if (payres.err_msg === 'get_brand_wcpay_request:fail') {
              reject({ message: 'fail', orderId: result.code })
            } else if (payres.err_msg === 'get_brand_wcpay_request:cancel') {
              reject({ message: 'cancel', orderId: result.code })
            } else {
              reject({ message: payres.errMsg, orderId: result.code })
            }
          })
        })
      }
    }
  } catch (err) {
    console.error('this.$payment err =>', err)
    if (err.code === '001') {
      window.location.href = err.Msg
      return
    } else {
      const toastMsg =
        typeof err === 'string'
          ? err
          : typeof err === 'object'
          ? err.message || err.Msg
          : PAYRESULTMSG['error']
      !config.hideMsg && $toast(PAYRESULTMSG[toastMsg] || toastMsg)
      const rejectObj = typeof err === 'string' ? { message: err } : err
      return Promise.reject(rejectObj)
    }
  }
}

function getState(code) {
  return new Promise(function (resolve, reject) {
    checkPayState(code, resolve, reject)
  })
}

function checkPayState(code, resolve, reject) {
  let count = 0
  async function callback(code, resolve, reject) {
    try {
      await $payApi.checkPayState(code)
      resolve({ message: 'success', orderId: code })
    } catch (err) {
      if (count < 100) {
        setTimeout(function () {
          callback(code, resolve, reject)
        }, 1500)
      } else {
        reject({ message: 'timeout', orderId: code })
      }
    }
  }
  return callback(code, resolve, reject)
}

function wxCallPay(data, callback) {
  if (typeof window.WeixinJSBridge == 'undefined') {
    if (document.addEventListener) {
      document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false)
    } else if (document.attachEvent) {
      document.attachEvent('WeixinJSBridgeReady', onBridgeReady)
      document.attachEvent('onWeixinJSBridgeReady', onBridgeReady)
    }
    onBridgeReady(data, callback)
  } else {
    onBridgeReady(data, callback)
  }
}

function onBridgeReady(data, callback) {
  window.WeixinJSBridge.invoke(
    'getBrandWCPayRequest',
    JSON.parse(data),
    function (res) {
      console.log('WeixinJSBridge onBridgeReady')
      typeof callback == 'function' && callback(res)
    }
  )
}

function isTest() {
  return (
    location.host.includes('wxhome.vzan') ||
    location.host.includes('vt.vzan') ||
    location.host.includes('localhost') ||
    location.host.includes('192.168')
  )
}

function isPhoneWeChat() {
  const ua = window.navigator.userAgent.toLowerCase()
  return (
    ua.match(/MicroMessenger/i) == 'micromessenger' && window.WeixinJSBridge
  )
}
